import { Component, OnInit } from '@angular/core';
import { BoxOfficesService } from '../services/box-offices.service';

@Component({
  selector: 'box-office',
  templateUrl: './box-office.component.html',
  styleUrls: ['./box-office.component.css']
})
export class BoxOfficeComponent implements OnInit {

  boxOfficeData  ; 
  constructor(private boxOffice:BoxOfficesService) 
  {
    this.boxOfficeData = this.boxOffice.boxOffice 
    
   }

  ngOnInit() {
  }

}
